<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    sessionStorage.setItem('isActive', 'homeActive')
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('isActive', this.$store.state.isActive)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue